<template>
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12.5 17.25C13.3975 17.25 14.125 16.5225 14.125 15.625C14.125 14.7275 13.3975 14 12.5 14C11.6025 14 10.875 14.7275 10.875 15.625C10.875 16.5225 11.6025 17.25 12.5 17.25Z"
            fill="black"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.75 7C7.75 4.37665 9.87665 2.25 12.5 2.25C15.1234 2.25 17.25 4.37665 17.25 7V10.25H18.5C19.4665 10.25 20.25 11.0335 20.25 12V20C20.25 20.9665 19.4665 21.75 18.5 21.75H6.5C5.5335 21.75 4.75 20.9665 4.75 20V12C4.75 11.0335 5.5335 10.25 6.5 10.25H7.75V7ZM15.75 7V10.25H9.25V7C9.25 5.20507 10.7051 3.75 12.5 3.75C14.2949 3.75 15.75 5.20507 15.75 7ZM6.5 11.75C6.36193 11.75 6.25 11.8619 6.25 12V20C6.25 20.1381 6.36193 20.25 6.5 20.25H18.5C18.6381 20.25 18.75 20.1381 18.75 20V12C18.75 11.8619 18.6381 11.75 18.5 11.75H6.5Z"
            fill="black"
        />
    </svg>
</template>
